<script>
  import DiscordGrayIcon from '$icons/DiscordGrayIcon.svelte';
  import EmailIcon from '$icons/EmailIcon.svelte';
  import TwitterBird from '$icons/TwitterBirdIcon.svelte';
  import VisitLinkIcon from '$icons/VisitLinkIcon.svelte';
  import { getAuthUser } from '$utils/auth.util';

  const requestFeature = async () => {
    let user = getAuthUser(false);
    if (user) {
      // canny is loaded from app.html
      // @ts-ignore
      Canny('identify', {
        appID: '62ac9d3bbeab1d0bae027b31',
        user: {
          // Replace these values with the current user's data
          email: user.email,
          name: user.userName,
          id: user._id,

          // These fields are optional, but recommended:
          avatarURL: user.profileImage
        }
      });
      window.open('https://feedback.thegarden.gg/');
    }
  };
  const SUPPORT_EMAIL = 'support@thegarden.gg';
  const TWITTER_URL = 'http://twitter.com/thegardengg';
  const DISCORD_URL = 'https://discord.gg/52ueSJmPxU';
</script>

<div class="mb-7">
  <div class="font-bold opacity-70">Contact Support</div>
  <a href="/terms" class="text-brand-green-50 hover:underline font-bold text-xs">
    Terms & Conditions
  </a>
</div>

<div class="w-full justify-center flex gap-5">
  <a href="mailto:{SUPPORT_EMAIL}">
    <div
      class="w-[60px] h-[60px] rounded-full
						border border-black border-opacity-10
						 flex items-center justify-center hover:bg-gray-100 group"
    >
      <div class="opacity-40 group-hover:opacity-60">
        <EmailIcon />
      </div>
    </div>
  </a>

  <a href={TWITTER_URL} target="_blank">
    <div
      class="w-[60px] h-[60px] rounded-full
						border border-black border-opacity-10
						flex items-center justify-center hover:bg-gray-100 group"
    >
      <div class="opacity-40 group-hover:opacity-60">
        <TwitterBird />
      </div>
    </div>
  </a>

  <a href={DISCORD_URL} target="_blank">
    <div
      class="w-[60px] h-[60px] rounded-full
							border border-black border-opacity-10
							flex items-center justify-center hover:bg-gray-100 group"
    >
      <div class="opacity-80 group-hover:opacity-100">
        <DiscordGrayIcon />
      </div>
    </div>
  </a>
</div>

<div class="flex gap-5">
  <button
    on:click={requestFeature}
    class="bg-brand-green-50 p-5 bg-opacity-10 text-black text-opacity-50 rounded-[50px] h-[50px] flex items-center justify-center mt-6 font-medium gap-[6px] cursor-pointer hover:bg-opacity-20 group"
  >
    <div class="opacity-70 group-hover:opacity-100 gap-2 flex align-middle items-center">
      Request a feature
      <VisitLinkIcon />
    </div>
  </button>

  <a
    href="https://thegardengg.notion.site/The-Garden-FAQ-bf1473575d6f470e95df101b2f943914"
    target="_blank"
    class="bg-brand-green-50 p-5 text-black text-opacity-50 rounded-[50px] h-[50px] flex items-center justify-center mt-6 font-medium gap-[6px] cursor-pointer hover:bg-opacity-20 group"
  >
    <div class="text-white opacity-70 group-hover:opacity-100 gap-2 flex align-middle items-center">
      FAQ
      <VisitLinkIcon class="stroke-white" />
    </div>
  </a>
</div>
